import { useState } from 'react';

import { Dialog } from '../../Dialog';

import { IconButtonTemplate } from '../../buttons/IconButtonTemplate';
import { ContactInfo } from '../ContactInfo';

import { colors } from '../../../../data/constants';
import {
  realtyButtonsTitles,
  realtyOwnersButtons,
} from '../../../../data/cardRealty';
import { useWhatsApp } from '../../../../hooks/useWhatsApp';
import { EVENT_LOG_SUBJECTS } from '../../../../redux/services/eventLog/eventLogApi';
import { fullName } from '../../../../utils/ui';

export const OwnersItemRealty = ({
  contact = {},
  realtyId,
  handleAddContactClick = () => {},
  setIsEditFormOpen = () => {},
  setContactId = () => {},
}) => {
  const sendWhatsApp = useWhatsApp();
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const { id, first_name, last_name, role, source, phone, email } = contact;
  // BE unmasks exactly the contacts the viewer may edit (owner, agency owner, admin)
  const canSee = !contact?.masked;
  const infoContact = `(${role?.title}${source?.title ? ` / ${source.title}` : ''})`;
  const infoContactTitle = canSee
    ? `${fullName(first_name, last_name)} ${infoContact}`
    : `*** ${infoContact}`;

  const handlePhoneEmailClick = () => {
    setIsInfoOpen(!isInfoOpen);
  };

  const handleOpenEditContact = () => {
    if (canSee) {
      setIsEditFormOpen(true);
      setContactId(id);
      handleAddContactClick();
    }
  };

  const buttonsHandlers = {
    [realtyButtonsTitles.phoneContact]: handlePhoneEmailClick,
    [realtyButtonsTitles.emailContact]: handlePhoneEmailClick,
    [realtyButtonsTitles.whatsUpContact]: () =>
      sendWhatsApp(phone, {
        subject_type: EVENT_LOG_SUBJECTS.REALTY,
        subject_id: realtyId,
        payload: { contact_id: id },
      }),
  };

  const buttonsActive = {
    [realtyButtonsTitles.phoneContact]:
      phone && phone.length > 0 ? colors.blueColor : colors.blackColor,
    [realtyButtonsTitles.emailContact]:
      email && email.length > 0 ? colors.blueColor : colors.blackColor,
  };

  return (
    <>
      <div className="flex items-center gap-1.5 p-0.5 w-full">
        {realtyOwnersButtons.map(button => {
          return (
            <IconButtonTemplate
              key={button.id}
              handleClick={buttonsHandlers[button.title]}
              icon={button.icon}
              classes={button.classes}
              isSmallBorder={true}
              color={buttonsActive[button.title]}
              size={button.size ? button.size : 16}
              tooltipText={button.tooltipText}
              disabled={!canSee}
            />
          );
        })}

        <div
          onClick={handleOpenEditContact}
          className={canSee ? 'cursor-pointer' : ''}
        >
          <span className="block text-xs text-blackColor">
            {infoContactTitle}
          </span>
        </div>
      </div>

      {isInfoOpen && (
        <Dialog
          content={
            <ContactInfo
              contact={contact}
              handleClose={() => setIsInfoOpen(false)}
            />
          }
          isOpen={isInfoOpen}
          onClose={() => setIsInfoOpen(false)}
        />
      )}
    </>
  );
};
